(function() {
  // 配置项
  const CONFIG = {
    containerSelector: '.cartx-b-wheel-container',
    closeSelector: '.cartx-b-close',
    buttonSelector: '.cartx-b-button',
    copyButtonSelector: '.cartx-b-complete-icon-2',
    requiredText: 'CART20',
    trackedAttribute: 'data-popup-tracked' // 统一的追踪标记
  };
  
  // 已追踪的弹窗集合（使用 WeakSet 自动管理内存）
  const trackedPopups = new WeakSet();
  
  // 统计上报函数（根据你的实际情况修改）
  function trackEvent(eventData = {}) {
    Shopify.analytics.publish("cartsee-popup", {
      type: eventData.type,
      event_name: eventData.name,
    });
  }
  
  // 检查弹窗是否符合条件
  function isValidPopup(container) {
    const text = container.textContent.trim();
    return text.includes(CONFIG.requiredText);
  }
  
  // 处理弹窗曝光
  function handleExposure() {
    trackEvent({
      type: "exposure",
      name: "",
    });
  }

  // 处理复制按钮点击
  function handleCopyClick() {
    trackEvent({
      type: "click",
      name: "popup_copy_button_click",
    });
  }
  
  // 处理关闭按钮点击
  function handleCloseClick() {
    trackEvent({
      type: "click",
      name: "popup_close_click",
    });
  }

  // 处理行动按钮点击
  function handleButtonClick() {
    trackEvent({
      type: "click",
      name: "popup_spin_button_click",
    });
  }
  
  // 初始化监听器
  function initTracking(container) {
    // 防止重复处理同一个弹窗
    if (trackedPopups.has(container)) {
      return;
    }
    
    // 检查是否符合条件
    if (!isValidPopup(container)) {
      return;
    }
    
    // 标记为已追踪
    trackedPopups.add(container);
    container.setAttribute(CONFIG.trackedAttribute, 'true');
    
    // 统计曝光
    handleExposure(container);
    
    // 绑定点击事件（事件委托）
    container.addEventListener('click', function(e) {
      const target = e.target;

      // 不符合条件的弹窗点击，忽略
      if( !isValidPopup(container) ) {
        return;
      }
      
      // 关闭按钮点击
      if (target.closest(CONFIG.closeSelector)) {
        handleCloseClick();
      }
      
      // 行动按钮点击
      if (target.closest(CONFIG.buttonSelector)) {
        handleButtonClick();
      }

      // 复制按钮点击
      if (target.closest(CONFIG.copyButtonSelector)) {
        handleCopyClick();
      }
    });
    
    console.log('✅ Popup tracking bound:', container);
  }
  
  // 使用 MutationObserver 监听 DOM 变化
  function observeDOM() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          // 检查是否是目标元素或包含目标元素
          if (node.nodeType === 1) { // Element node
            // 情况1：添加的节点本身就是目标容器
            if (node.matches && node.matches(CONFIG.containerSelector)) {
              initTracking(node);
            } 
            // 情况2：添加的节点包含目标容器
            else if (node.querySelector) {
              const container = node.querySelector(CONFIG.containerSelector);
              if (container) {
                initTracking(container);
              }
            }
          }
        });
      });
    });
    
    // 开始观察
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    return observer;
  }
  
  // 初始化
  function init() {
    console.log('🚀 Initializing popup tracker...');
    
    // 先启动 MutationObserver
    observeDOM();
    
    // 然后检查页面上是否已存在弹窗
    const existingContainer = document.querySelector(CONFIG.containerSelector);
    if (existingContainer) {
      console.log('📦 Found existing popup, tracking...');
      initTracking(existingContainer);
    }
    
    console.log('✅ Popup tracker initialized');
  }
  
  // 启动（确保 DOM 已准备好）
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
